import Store from 'd2-ui/lib/store/Store';

export default Store.create();



// WEBPACK FOOTER //
// ./src/List/sharing.store.js